<template>
  <div>
    <h1>Organization Dashboard</h1>
 
    <v-row align="start" justify="center">
      <v-col  md="3">
        <v-card class="mx-auto" color="primary" dark min-width="150"  max-width="400">
          <v-card-title>
            <v-icon large left> mdi-book </v-icon>
            <span class="title font-weight-light">Publications</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.PublicationCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

         <v-col  md="3">
        <v-card class="mx-auto" color="primary" dark min-width="150"  max-width="400">
          <v-card-title>
            <v-icon large left> mdi-book </v-icon>
            <span class="title font-weight-light">Journals</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.JournalCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card class="mx-auto" color="primary"  dark min-width="150" max-width="400">
          <v-card-title>
            <v-icon large left> mdi-account </v-icon>
            <span class="title font-weight-light">Users</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.UserCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="3">
        <v-card class="mx-auto" color="primary" dark min-width="150" max-width="400">
          <v-card-title>
            <v-icon large left> mdi-license </v-icon>
            <span class="title font-weight-light">Licenses</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.LicenseCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
         <v-col md="3">
        <v-card class="mx-auto" color="primary" dark min-width="150" max-width="400">
          <v-card-title>
            <v-icon large left> mdi-library-books </v-icon>
            <span class="title font-weight-light">Collections</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.CollectionCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col >
         <v-col md="3">
        <v-card class="mx-auto" color="primary" dark min-width="150" max-width="400">
          <v-card-title>
            <v-icon large left> mdi-account-multiple </v-icon>
            <span class="title font-weight-light">Groups</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.GroupCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col md="3">
        <v-card class="mx-auto" color="primary" dark min-width="150" max-width="400">
          <v-card-title>
            <v-icon large left> mdi-book-plus-multiple</v-icon>
            <span class="title font-weight-light">Subscriptions</span>
          </v-card-title>
          <v-divider class="divider"></v-divider>
          <v-card-text class="cardText">
            <div>
              <div class="count">{{data.GroupSubscriptionCount}}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col></v-col>
    </v-row>


  <!--
    <h1 class="mt-5">Top 5 Publications</h1>
    <v-card elevation="2">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Publication</th>
              <th style="width: 150px">License Count</th>
            </tr>
          </thead>

          <tbody>
             <tr v-for="item in list" :key="item.Title">
                 <td>{{ item.Title }}</td>
                 <td>{{ item.LicenseCount }}</td>
              </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    -->
  </div>
</template>
<script>
import * as api from "@/api";

export default {
  name: "OrgDashboard",
    created() {
    this.geStatistic();
    //this.getBestPublications();
  },
  methods: {
    geStatistic() {
      new Promise((resolve, reject) => {
        api
          .getAll("dashboard")
          .then((response) => {
            //console.log(response);
            this.data = response.data[0];
            console.log(response.data)
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getBestPublications()
    {
       new Promise((resolve, reject) => {
        api
          .getAll("dashboard/best-publications")
          .then((response) => {
            //console.log(response);
            this.list = response.data;
            console.log(response.data)
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },
  data() {
    return {
       data: {},
       list: [],
    };
  },
};
</script>

<style scoped>
.count {
  font-size: 72px;
  font-weight: 400;
  text-align: center;
  margin-top: 20px;
  color: white;
}
.cardText {
  height: 100px;
}
.title {
  text-align: center;
}
.divider {
  color: white;
  border-width: 1px;
}
</style>


// WEBPACK FOOTER //
// src/views/Organization/OrgDashboard.vue